import axiosInstance from "../../api/axiosInstance";

function rangeParams({ from, to } = {}) {
  const params = new URLSearchParams();
  if (from) params.set("from", new Date(from).toISOString());
  if (to) params.set("to", new Date(to).toISOString());
  return params;
}

export const fetchAdTelemetrySummaryAPI = async (range) => {
  const res = await axiosInstance.get(
    `ads/telemetry/summary?${rangeParams(range).toString()}`,
  );
  return res.data?.data;
};

export const fetchAdTelemetryWaitPercentilesAPI = async (range) => {
  const res = await axiosInstance.get(
    `ads/telemetry/wait-percentiles?${rangeParams(range).toString()}`,
  );
  return res.data?.data;
};

export const fetchAdTelemetryLoadPercentilesAPI = async (range) => {
  const res = await axiosInstance.get(
    `ads/telemetry/load-percentiles?${rangeParams(range).toString()}`,
  );
  return res.data?.data;
};

export const fetchAdTelemetryTimeseriesAPI = async (range) => {
  const res = await axiosInstance.get(
    `ads/telemetry/timeseries?${rangeParams(range).toString()}`,
  );
  return res.data?.data;
};

export const fetchAdTelemetryWaitTimeseriesAPI = async (range) => {
  const res = await axiosInstance.get(
    `ads/telemetry/wait-timeseries?${rangeParams(range).toString()}`,
  );
  return res.data?.data;
};

export const fetchAdTelemetryErrorsAPI = async (range) => {
  const res = await axiosInstance.get(
    `ads/telemetry/errors?${rangeParams(range).toString()}`,
  );
  return res.data?.data;
};

export const fetchAdTelemetryPlatformsAPI = async (range) => {
  const res = await axiosInstance.get(
    `ads/telemetry/platforms?${rangeParams(range).toString()}`,
  );
  return res.data?.data;
};

export const fetchAdTelemetryEventsAPI = async (range, { limit, event } = {}) => {
  const params = rangeParams(range);
  if (limit) params.set("limit", String(limit));
  if (event) params.set("event", String(event));
  const res = await axiosInstance.get(
    `ads/telemetry/events?${params.toString()}`,
  );
  return res.data?.data;
};
